if (!Error.captureStackTrace) {
  //polyfill for some browsers such as Safari:
  //* based on https://github.com/inf3rno/u3/blob/master/lib/cache.js and
  //* https://github.com/inf3rno/error-polyfill/blob/c7a844d0327ede62237b0a8a701a708fc85eaa89/lib/prepareStackTrace.js
  const cache = function (fn: unknown) {
    let called = false;
    let store: unknown;

    if (!(fn instanceof Function)) {
      called = true;
      store = fn;
      //eslint-disable-next-line no-param-reassign
      fn = null;
    }

    return function () {
      if (!called) {
        called = true;
        //By inspection, if !called, then `fn` is a function, so fn.apply() is defined
        /* eslint-disable @typescript-eslint/ban-ts-comment,no-param-reassign,prefer-rest-params */
        //@ts-ignore
        store = fn.apply(this, arguments);
        fn = null;
        /* eslint-enable @typescript-eslint/ban-ts-comment,no-param-reassign */
      }
      return store;
    };
  };

  const prepareStackTrace = function (
    throwable: Error,
    frames: { toString(): string }[],
    warnings?: string[],
  ) {
    let string = '';
    string += throwable.name || 'Error';
    string += ': ' + (throwable.message || '');
    if (warnings instanceof Array)
      for (const warningIndex in warnings) {
        const warning = warnings[warningIndex];
        string += '\n   # ' + warning;
      }
    for (const frameIndex in frames) {
      const frame = frames[frameIndex];
      string += '\n   at ' + frame.toString();
    }
    return string;
  };

  Error.captureStackTrace = function (
    throwable: Error /*terminator?: Function*/,
  ) {
    Object.defineProperties(throwable, {
      stack: {
        configurable: true,
        get: cache(function () {
          return (Error.prepareStackTrace || prepareStackTrace)(throwable, []);
        }),
      },
      cachedStack: {
        configurable: true,
        writable: true,
        enumerable: false,
        value: true,
      },
    });
  };
}

//Note: There is not a standard for AbortError, so use `isAbortErrorLike()` to
//test if an object is AbortError-like
//* But AbortController specifies the name must be 'AbortError'
//* For fetch() errors caused by an AbortSignal, the `type` is 'DOMException'
export class AbortError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  get name(): string {
    return this.constructor.name;
  }
  get [Symbol.toStringTag](): string {
    return this.constructor.name;
  }
}

export const isAbortErrorLike = (candidate: unknown): boolean => {
  return (
    candidate instanceof AbortError ||
    (candidate instanceof Error && candidate.name === 'AbortError')
  );
};
